import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { mediaQuery } from '@styles/index';
import Banner from './Banner';

const ttuConfig = {
  imgUrl: 'ttu/ttu_illustration_call.svg',
  title: 'Have questions about the batches?',
  subTitle: 'Our expert can answer all your questions'
};

const Wrapper = styled.div`
  grid-column: span 16;
  .ttu-title {
    width: 350px;
    ${mediaQuery.uptoTablet} {
      width: 250px;
    }
  }
`;

const PlatformTTU = ({ goalDetails, className, ttuEventsProps }) => {
  ttuConfig.ttuEventsProps = ttuEventsProps || {};
  return (
    <Wrapper>
      <Banner
        goalDetails={goalDetails}
        ttuConfig={ttuConfig}
        className={className}
      />
    </Wrapper>
  );
};

export default PlatformTTU;

PlatformTTU.propTypes = {
  goalDetails: PropTypes.objectOf(PropTypes.any).isRequired,
  className: PropTypes.string
};

PlatformTTU.defaultProps = {
  className: ''
};
